@import "~@uppy/core/dist/style.css";
@import "~@uppy/progress-bar/dist/style.css";
@import "../covet-pics-popup/covet-gallery-popup";

// colors
$white: #FFFFFF;
$gray: #919EAB;
$gray-lite: #DFE3E8;
$gray-lite2: #C4CDD5;
$gray-lite3: #F9FAFB;
$black: #000000;
$black-lite: #212B36;
$blue: #007ACE;
$blue-dark: #5C6AC4;
$orange: #F7786B;
$orange-lite: #EBCC78;
$green: #23FFFFFF;
$violet: #ABA0EB;

*, *::before, *::after {
  box-sizing: border-box;
}

:host {
    // TODO check how it works on real sites
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // TODO check how it works on real sites END
}

.upload {
  font-family: var(--covet-pics-font-family);
  max-width: 480px;
  width: 100%;
  max-height: 510px;
  height: 100%;
  border-radius: 8px;
  background-color: $white;
  padding: 46px 64px;
  box-sizing: border-box;
  position: relative;
  display: block;
  margin: auto;
  z-index: 1;

  @media only screen and (max-width: 479px) {
    max-width: calc(100% - 16px);
    padding: 48px 16px 40px 16px;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin-top: 0;
  }
}

.upload-close {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  overflow: hidden;
  cursor: pointer;
  position: absolute;
  top: 0%;
  right: 0%;
  transform: translate(-16px, 16px);
  border: none;
  background-color: transparent;
  &:after, &:before {
    content: "";
    position: absolute;
    width: 23px;
    height: 2px;
    left: 50%;
    top: 50%;
    background-color: $gray;
    transform-origin: center center;
    transition: background-color 0.3s ease;
  }
  &:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  &:disabled {
    cursor: auto;
  }
  &:hover, &:focus, &:active, &.active {
    &:after, &:before {
      background-color: $black;
    }
  }
}

.upload-form {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.upload-scroll {
  width: calc(100% + var(--covet-pics-scrollbar-width));
  display: block;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  margin-right: calc(var(--covet-pics-scrollbar-width) * (-1));
  padding-right: var(--covet-pics-scrollbar-padding);
}

.upload-step {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.step1 {
    transition: opacity 0.5s ease, height 0.5s ease;
    opacity: 1;
    height: calc(352px + 64px); // TODO fix this
  }
  &.step1.leave {
    transition: opacity 0.5s ease;
    opacity: 0;
  }
  &.step1.enter {
    transition: opacity 0.25s ease;
    opacity: 1;
  }
  &.step1.leave-to {
    overflow: hidden;
    height: 0;
    opacity: 0;
  }
  &.step1.no-skip-btn {
    height: 352px;
    overflow: hidden;
  }
  &.step2 {
    margin-top: 20px;
    height: auto;
  }
  &.step2.no-margin {
    margin-top: 0;
  }
  &.step3 {
    opacity: 0;
    transition: opacity 0.15s ease-in;
    transition-delay: 0.25s;
  }
  &.step3.enter {
    opacity: 1;
  }
  &.step4 {
    opacity: 0;
    transition: opacity 0.25s ease-in;
    transition-delay: 0.25s;
  }
  &.step4.enter {
    opacity: 1;
  }
  &.step4.leave {
    transition: opacity 0.25s ease-out;
    opacity: 0;
  }
}

.upload-h2 {
  color: $black-lite;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  margin-bottom: 8px;
  &.top {
    line-height: 1.4;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.progress {
    margin-bottom: 20px;
  }
  &.step2 {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  &.step2.enter {
    opacity: 1;
    transition: opacity 0.1s ease-out;
  }
  &.step4 {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  &.step4.enter {
    opacity: 1;
    transition: opacity 0.1s ease-out;
  }
}

.upload-h3 {
  height: 16px;
  color: $black-lite;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  font-weight: 400;
  margin-bottom: 24px;
}

.upload-text {
  font-size: 11px;
  line-height: 16px;
  color: $gray;
  text-align: center;
  display: block;
  &.privacy {
    font-size: 12px;
    text-align: left;
    width: 100%;
    margin-bottom: 14px;
  }
  &.completed {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: auto;
  }
}
.upload-text-drop {
  opacity: 1;
  transition: opacity 0.05s ease;
  &.no-active {
    opacity: 0;
  }
  &.enter {
    transition: opacity 0.15s ease;
    opacity: 1;
  }
}

.upload-drop {
  position: relative;
}

.upload-drop-progress {
  display: block;
  position: relative;
  height: 5px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 11px;
  overflow: hidden;
  position: absolute;
  top: 5px;
  left: 0;
  background-color: $black;
  width: 0%;
  transition: width 0.4s ease;
  &.active {
    width: 100%;
  }
  &.no-active {
    width: 0%;
    transition: none;
  }
  &.leave {
    transition: opacity 0.1s ease-out;
    opacity: 0;
  }
}

.dropzone {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  position: relative; // TODO check before move to production
}

.dropzone-graphics {
  width: 100%;
  height: 280px;
  border-radius: 4px;
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $gray-lite3;

  .svg-drop-files {
    .path-main {
      position: relative;
      top: 50%;
      left: 50%;
      transform-origin: center center;
      transform: translateX(12.5%);
      transition: all 0.3s ease;

      .path-main-paint {
        fill: $gray-lite;
        transition: fill 0.3s ease;
      }
    }
    .path-background {
      position: relative;
      transform-origin: center center;
      transform: rotate(10deg) translate(-2%, 0.5%);
      opacity: 0;
      transition: all 0.2s ease;
      transition-delay: 0.1s;
    }
    &.leave {
      opacity: 0;
    }
    &.enter {
      opacity: 1;
      transition: opacity 0.25s ease-in;
    }
  }

  &:hover, &:active, &:focus {
    .svg-drop-files {
      .path-main {
        transform: translateX(3%);
        .path-main-paint {
          fill: $black-lite;
        }
      }
      .path-background {
        transform: rotate(10deg) translate(1%, 0.5%);
        opacity: 1;
        transition: all 0.3s ease;
      }
    }
  }
}

.form-control {
  font-family: var(--covet-pics-font-family);
  font-size: 14px;
  line-height: 16px;
  padding: 12px 16px;
  display: block;
  width: 100%;
  border: 1px solid $gray-lite;
  border-radius: 4px;
  background-color: transparent;
  margin-bottom: 14px;
  color: $black-lite;
  transition: border-color 0.25s ease;
  outline: none !important;
  box-shadow: none !important;
  appearance: none;
  &::placeholder {
    color: $gray;
  }
  &:hover, &:active, &:focus, &.active {
    border: 1px solid $black-lite;
    box-shadow: none !important;
    appearance: none;
  }
  &.warning {
    border: 1px solid $orange;
  }
}

.upload-link {
  color: $blue;
  transition: color 0.25s ease;
  text-decoration: none;
  font-size: 12px;
  &:hover, &:active, &:focus, &.active {
    color: darken($blue, 15%); // TODO fix hover color
  }
}

// ver 3
.upload-gallery {
  position: absolute;
  height: calc(280px - 48px);
  width: 100%;
  background-color: $gray-lite3;
  border-radius: 4px;
  opacity: 0;
  left: 50%;
  transform-origin: center center;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  transition: transform 0.3s ease-in, opacity 0.3s ease-in;
  z-index: 1;
  overflow: hidden;
  &.no-active {
    z-index: -1;
  }
  &.active {
    z-index: 1; // TODO check value 0
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.upload-img-wrap {
  height: calc(180px * var(--covet-pics-upload-img-ratio));
  width: calc(180px * var(--covet-pics-upload-img-ratio));
  border-radius: 8px;
  display: flex;
  position: absolute;
  transform-origin: center center;
  z-index: 5;
  transition: all 0.2s ease;
  cursor: pointer;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  overflow: hidden;
  cursor: pointer;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    transition: background-color 0.2 ease;
  }
  &:hover, &:active, &:focus {
   &:after {
      background-color: rgba($black-lite, 0.4);
   }
   .icon-cross {
     opacity: 1;
     z-index: 1;
   }
  }
  @media (any-hover: none) {
    &:after {
       background-color: rgba($black-lite, 0.4);
    }
    .icon-cross {
      opacity: 1;
      z-index: 1;
    }
  }
  &.before-enter, .leave {
    pointer-events: none;
  }

  // 1
  &.wrap-pos-1 {
    transition: transform 0.3s ease;
    z-index: 5;
    &.img-count-1.enter {
      transform: translate(calc(-50% - 38px * var(--covet-pics-upload-img-ratio)), -50%);
    }
    &.img-count-2.enter {
      transform: translate(calc(-50% - 60px * var(--covet-pics-upload-img-ratio)), -50%);
    }
    &.img-count-3.enter {
      transform: translate(calc(-50% - 72px * var(--covet-pics-upload-img-ratio)), -50%);
    }
    &.img-count-4.enter {
      transform: translate(calc(-50% - 72px * var(--covet-pics-upload-img-ratio)), -50%);
    }

    &.img-count-1.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-1.leave-to2 {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%) scale(0.9);
      opacity: 0;
      pointer-events: none;
      transition: transform 0.2s ease, opacity 0.2s ease;
    }
    &.img-count-2.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-3.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-4.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
  }
  // 2
  &.wrap-pos-2 {
    z-index: 4;
    transition: transform 0.3s ease-out, opacity 0.3s ease-in;
    height: calc(140px * var(--covet-pics-upload-img-ratio));
    width: calc(140px * var(--covet-pics-upload-img-ratio));
    opacity: 0;
    transform: translate(-50%, -50%) rotate(12deg);
    &.img-count-1.before-enter {
      transition-delay: 0.1s;
      transform: translate(calc(-50% - 18px * var(--covet-pics-upload-img-ratio)), -50%) rotate(0deg);
    }
    &.img-count-1.enter {
      transform: translate(calc(-50% + 42px * var(--covet-pics-upload-img-ratio)), -50%) rotate(15deg);
      opacity: 1;
    }
    &.img-count-2.before-enter {
      transition-delay: 0.1s;
      transform: translate(calc(-50% - 40px * var(--covet-pics-upload-img-ratio)), -50%) rotate(0deg);
    }
    &.img-count-2.enter {
      transform: translate(calc(-50% + 22px * var(--covet-pics-upload-img-ratio)), -50%) rotate(15deg);
      opacity: 1;
    }
    &.img-count-3.before-enter {
      transition-delay: 0.1s;
      transform: translate(calc(-50% - 51px * var(--covet-pics-upload-img-ratio)), -50%);
    }
    &.img-count-3.enter {
      transform: translate(calc(-50% + 8px * var(--covet-pics-upload-img-ratio)), -50%) rotate(15deg);
      opacity: 1;
    }
    &.img-count-4.before-enter {
      transition-delay: 0.1s;
      transform: translate(calc(-50% - 51px * var(--covet-pics-upload-img-ratio)), -50%);
    }
    &.img-count-4.enter {
      transform: translate(calc(-50% + 8px * var(--covet-pics-upload-img-ratio)), -50%) rotate(15deg);
      opacity: 1;
    }
    &.img-count-1.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-1.leave-to2 {
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.05s ease;
    }
    &.img-count-2.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-3.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-4.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
  }
  // 3
  &.wrap-pos-3 {
    z-index: 3;
    height: calc(108px * var(--covet-pics-upload-img-ratio));
    width: calc(108px * var(--covet-pics-upload-img-ratio));
    transition: transform 0.3s ease-out, opacity 0.3s ease-in;
    transform: translate(-50%, -26%) rotate(25deg);
    opacity: 0;
    &.img-count-2.before-enter {
      transition-delay: 0.2s;
      transform: translate(calc(-50% + 35px * var(--covet-pics-upload-img-ratio)), -40%) rotate(15deg);
    }
    &.img-count-2.enter {
      transform: translate(calc(-50% + 78px * var(--covet-pics-upload-img-ratio)), -26%) rotate(30deg);
      opacity: 1;
    }
    &.img-count-3.before-enter {
      transition-delay: 0.2s;
      transform: translate(calc(-50% + 21px * var(--covet-pics-upload-img-ratio)), -38%) rotate(15deg);
    }
    &.img-count-3.enter {
      transform: translate(calc(-50% + 76px * var(--covet-pics-upload-img-ratio)), -26%) rotate(30deg);
      opacity: 1;
    }
    &.img-count-4.before-enter {
      transition-delay: 0.2s;
      transform: translate(calc(-50% + 21px * var(--covet-pics-upload-img-ratio)), -38%) rotate(15deg);
    }
    &.img-count-4.enter {
      transform: translate(calc(-50% + 76px * var(--covet-pics-upload-img-ratio)), -26%) rotate(30deg);
      opacity: 1;
    }
    &.img-count-2.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-3.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-4.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
  }
  // 4
  &.wrap-pos-4 {
    z-index: 2;
    height: calc(64px * var(--covet-pics-upload-img-ratio));
    width: calc(64px * var(--covet-pics-upload-img-ratio));
    transition: transform 0.3s ease-out, opacity 0.3s ease-in;
    opacity: 0;
    transform: translate(-50%, 47%) rotate(40deg);
    &.img-count-3.before-enter {
      transition-delay: 0.3s;
      transform: translate(calc(-50% + 90px * var(--covet-pics-upload-img-ratio)), 20%) rotate(30deg);
    }
    &.img-count-3.enter {
      transform: translate(calc(-50% + 120px * var(--covet-pics-upload-img-ratio)), 47%) rotate(45deg);
      opacity: 1;
    }
    &.img-count-4.before-enter {
      transition-delay: 0.3s;
      transform: translate(calc(-50% + 90px * var(--covet-pics-upload-img-ratio)), 20%) rotate(30deg);
    }
    &.img-count-4.enter {
      transform: translate(calc(-50% + 120px * var(--covet-pics-upload-img-ratio)), 47%) rotate(45deg);
      opacity: 1;
    }
    &.img-count-3.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
    &.img-count-4.leave {
      pointer-events: none;
      transition: transform 0.2s ease;
      transform: translate(-50%, -50%);
    }
  }

  &.upload-img-upload {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23333' stroke-width='1' stroke-dasharray='6%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    display: block;
    background-color: $white;
    &:after {
      display: none;
    }
    &:hover, &:active, &:focus {
      &:after {
        display: none;
      }
     }
  }
}

.upload-img {
  object-fit: cover;
  width: 100%;
  border-radius: 8px;
}

.icon-cross {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  overflow: hidden;
  position: absolute;
  top: calc(16px * var(--covet-pics-upload-img-ratio));
  right: calc(16px * var(--covet-pics-upload-img-ratio));
  background-color: transparent;
  opacity: 0;
  transition: opacity 0.2s ease;
  transform-origin: center center;
  will-change: transform;
  &:after, &:before {
    content: "";
    position: absolute;
    width: 13px;
    height: 1px;
    left: 50%;
    top: 50%;
    background-color: $white;
    transform-origin: center center;
    transition: background-color 0.3s ease;
  }
  &:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  &.plus {
    &:after {
      width: 12px;
      transform: translate(-50%, -50%);
      background-color: $black-lite;
    }
    &:before {
      transform: translate(-50%, -50%) rotate(90deg);
      background-color: $black-lite;
      width: 12px;
    }
  }
}

.upload-img-count {
  position: absolute;
  bottom: 9px;
  right: 12px;
  color: $gray;
  opacity: 0;
  font-size: 12px;;
  transition: opacity 0.2s ease;
  z-index: 1;
  &.enter {
    opacity: 1;
  }
}

.upload-submit {
  font-family: var(--covet-pics-font-family);
  color: $white;
  background-color: $black;
  border-color: $black;
  padding: 8.5px;
  font-size: 14px;
  line-height: unset;
  border-radius: 2px;
  text-align: center;
  user-select: none;
  border: 1px solid transparent;
  transition: background-color .25s ease;
  display: block;
  width: 100%;
  cursor: pointer;
  &:hover, &:active, &:focus, &.active {
    background-color: lighten($black, 20%); // TODO fix hover color
  }
  &:disabled {
    cursor: default;
    // opacity: .65;
    border: 1px solid $gray-lite;
    background-color: $gray-lite;
  }
  &.reset {
    background-color: $black-lite;
    padding: 12.5px 8.5px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    opacity: 0;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: background-color .25s ease, opacity 0.2s ease;
    &.enter {
      opacity: 1;
    }
  }
}
.icon-down-skip {
  path {
    fill: $gray;
  }
}
.btn-skip {
  color: $gray;
  font-family: var(--covet-pics-font-family);
  font-size: 14px;
  line-height: unset;
  border: 1px solid transparent;
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin-top: 24px;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:hover, &:active, &:focus, &.active {
    color: $black;
    .icon-down-skip {
      path {
        fill: $black;
      }
    }
  }
}
.star-rating {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  &.no-active {
    visibility: hidden;
    opacity: 0;
  }
}

.icon-star {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-right: 16px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
  &:after {
    display: none;
  }
  &:hover, &:active, &:focus, &.active {
    .svg-star path {
      fill: rgba($black, 1);
    }
  }
  &.warning {
    .svg-star path {
      stroke: red;
      stroke-width: 0.6;
    }
  }
}

.svg-star {
  width: 100%;
  height: 100%;
  path {
    stroke-width: 0.6;
    stroke: $black;
    transition: fill 0.3s ease;
  }
}

.svg-completed {
  width: 96px;
  height: 96px;
  margin-bottom: 6px;
  margin-top: auto;
}

.progress-bar {
  width: 60%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  .uppy-ProgressBar {
    height: 5px;
  }
  .uppy-ProgressBar-inner {
    background-color: $black;
    box-shadow: 0 0 10px $black-lite;
  }
}

.upload-brand-link {
  position: absolute;
  width: 135px;
  height: auto;
  outline: none !important;
  transition: none;
  opacity: 1;
  will-change: transform;
  right: 16px;
  bottom: -24px;
  display: block;
  .svg-brand {
    width: 100%;
  }
  .svg-text {
    fill: $gray-lite;
    transition: fill 0.2s ease;
  }
  .svg-text-p {
    fill: $gray-lite;
    transition: fill 0.2s ease;
  }
  .svg-text-i {
    fill: $gray-lite;
    transition: fill 0.2s ease;
  }
  .svg-text-c {
    fill: $gray-lite;
    transition: fill 0.2s ease;
  }
  .svg-text-s {
    fill: $gray-lite;
    transition: fill 0.2s ease;
  }
  &:hover, &:focus, &:active, &.active {
    .svg-text {
      fill: $gray-lite;
    }
    .svg-text-p {
      fill: $orange-lite;
    }
    .svg-text-i {
      fill: $orange;
    }
    .svg-text-c {
      fill: $green;
    }
    .svg-text-s {
      fill: $violet;
    }
  }
  @media only screen and (max-width: 479px) {
    right: 24px;
  }
}

.notification {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  z-index: -1;
  &.active {
    z-index: 5;
    .notification-message {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
.notification-message {
  position: relative;
  width: 480px;
  border-radius: 4px;
  background-color: $black;
  height: 50px;
  top: 0;
  transform: translateY(10px);
  transition: transform 0.25s ease, opacity 0.25s ease;
  opacity: 0;
  color: $white;
  padding: 10px;
  font-size: 16px;
  letter-spacing: 0.3px;
  @media only screen and (max-width: 479px) {
    max-width: calc(100% - 32px);
    font-size: 12px;
    padding: 8px 8px;
  }
}

// helpers
.hidden {
  display: none;
}

.invisible {
  visibility: hidden;
}
